<!-- 
Redirects to a preview of the invoice PDF template. Doing it this way instead of 
going directly to the invoice-template-preview route means the user can see a nice
waiting indicator while waiting for the pdf to download.
-->
<template>
  <div>
    <strong>Opening preview of the invoice PDF template, please wait...</strong>
  </div>
</template>

<script>
export default {
  computed: {
    levyCollectionId() {
      return parseInt(this.$route.params.levyCollectionId);
    }
  },
  mounted() {
    this.redirect();
  },
  methods: {
    async redirect() {
      const url = `/api/levy-collections/${this.levyCollectionId}/invoice-template-preview`;
      window.location.href = url;
    }
  }
};
</script>
